export const INVITE_OPEN_MODAL = 'INVITE_OPEN_MODAL';
export const INVITE_CLOSE_MODAL = 'INVITE_CLOSE_MODAL';

export function openInviteModal() {
  return {
    type: INVITE_OPEN_MODAL
  };
}

export function closeInviteModal() {
  return {
    type: INVITE_CLOSE_MODAL
  };
}
